import { css } from "@compiled/react";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { GlobalFooterBottom } from "./global-footer-bottom";
import { GlobalFooterTop } from "./global-footer-top";

// ==================================================================
// CSS styling
// ==================================================================
const globalFooterStyle = css({
    backgroundColor: "#f4f5f7",
    padding: "16px 0 0 0",
    position: "relative",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both"
});

// ==================================================================
// Type Props
// ==================================================================
export type GlobalFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const GlobalFooter = ({
    selectedLanguage,
    onLanguageChangeHandler
}: GlobalFooterPatternProps) => (
    <UFOSegment name="global-footer">
        <footer css={globalFooterStyle}>
            <GlobalFooterTop />
            <GlobalFooterBottom
                selectedLanguage={selectedLanguage}
                onLanguageChangeHandler={onLanguageChangeHandler}
            />
        </footer>
    </UFOSegment>
);
